// America/New_York time helpers
const TZ = "America/New_York";

export function nyNow() {
    const now = new Date();
    const date = new Intl.DateTimeFormat("en-US", {
        timeZone: TZ,
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
    }).format(now);
    const time = new Intl.DateTimeFormat("en-US", {
        timeZone: TZ,
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    }).format(now);
    return { date, time };
}

export function nyFormat(iso, opts = {}) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return new Intl.DateTimeFormat("en-US", {
        timeZone: TZ,
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        ...opts,
    }).format(d);
}

export function nyGreeting() {
    const h = parseInt(
        new Intl.DateTimeFormat("en-US", { timeZone: TZ, hour: "numeric", hour12: false }).format(new Date()),
        10
    );
    if (h < 5) return "Rest well";
    if (h < 12) return "Good morning";
    if (h < 17) return "Good afternoon";
    if (h < 21) return "Good evening";
    return "Peaceful night";
}

export const NY_TZ = TZ;
